// Implements: F-UIX-019
/**
 * The platform admin's ceiling of one organization (S4d-1, USG.21):
 * `GET` and `PUT /api/admin/organizations/{org_id}/usage-ceiling`.
 *
 * Only the platform admin is answered (anybody else gets `403`, an unknown organization `404`),
 * which is why the route guard decides first and this module is never reached by another role.
 * The `PUT` replaces the whole ceiling and is sent at most once (`retry: false`): it is not a
 * paid call, but a mutating request is never repeated behind the admin's back (checklist 13).
 */

import { ceilingPath } from "../../../shared/api/ceilingRoute";
import { httpRequest } from "../../../shared/api/httpClient";
import type { CeilingRequest, CeilingView } from "../../../types/ceiling";

export { CEILING_ROUTE, ceilingPath } from "../../../shared/api/ceilingRoute";

export async function fetchCeiling(organizationId: string, signal?: AbortSignal): Promise<CeilingView> {
  const body = await httpRequest<CeilingView>(ceilingPath(organizationId), { signal });
  if (body === undefined) throw new Error("The ceiling answered no body.");
  return body;
}

export async function saveCeiling(organizationId: string, ceiling: CeilingRequest): Promise<CeilingView> {
  const body = await httpRequest<CeilingView>(ceilingPath(organizationId), {
    method: "PUT",
    body: ceiling,
    retry: false,
  });
  if (body === undefined) throw new Error("The ceiling answered no body.");
  return body;
}
